import React from 'react'
import { faUser } from '@fortawesome/free-solid-svg-icons'

import SessionNewForm from './newForm'
import Header from '../utils/Header'
import { ButtonLink } from '../utils/Button'

const SessionNew = () => {
  return (
    <div>
      <Header
        className="mb-6"
        icon={faUser}
        header="Your Account"
        subHeader={
          <>
            We don't use passwords.
            <br />
            We email you a special link to access your account.
          </>
        }
      />

      <SessionNewForm />

      <div className="text-xl font-semibold my-2">Haven't used us yet? Try it out for free.</div>

      <ButtonLink to="/new" color="green">
        Create a new request!
      </ButtonLink>
    </div>
  )
}
export default SessionNew
